export const ERROR_MESSAGES = 
{ GENERIC_ERROR: 'An error has occurred. Please try again later.', 
    NETWORK_ERROR: 'Network error. Please check your internet connection.', 
    INVALID_INPUT: 'Invalid input. Please check the fields and try again.' };